if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: false,
			numberFilterTree: 2,
			selectOptionContainer: '.grid__item .card-wrapper',
			stickyFixTopPos: true
		},
		selector: {
			otpTopCartCount: '.cart-count-bubble'
		}
	};
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

(function () {
	var hasOnlyDefaultVariant = false,
		onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

	BoostPFS.inject(this);

	Labels.search.seoTitleOne = "Search: {{ count }} result found for {{ terms }} - Matangi";
  	Labels.search.seoTitleOther = "Search: {{ count }} results found for {{ terms }} - Matangi";

	/* For Filter Setting Layout */
	Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		hasOnlyDefaultVariant = data.variants.length === 1;

		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		priceVaries = data.price_min !== data.price_max; // Check a product has many prices

		// Convert images to array
		images = data.images_info;

		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];

		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			let paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});

			if (typeof paramVariant[0] !== 'undefined') {
				firstVariant = paramVariant[0];
			}
		} else {
			for (let i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		onSale = firstVariant.compare_at_price > firstVariant.price; // Check if current variant is on sale

		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) {
			data = this.data;
		}

		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		return this.buildTemplate(data);
	};
	/************************** END BUILD PRODUCT LIST **************************/

	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	ProductGridItem.prototype.buildTemplate = function (product) {
		let template = boostPFSTemplate.productGridItemHtml.replace(/{{productId}}/g, product.id);

		let imagesHtml 	= this.buildImages(product);
		let bagdesHtml 	= this.buildBadges(product);
		let metaHtml 	= this.buildMeta(product);

		template = template.replace(/{{productImages}}/g, imagesHtml);
		template = template.replace(/{{productBadges}}/g, bagdesHtml);
		template = template.replace(/{{productMeta}}/g, metaHtml);

		// Add main attribute (Always put at the end of this function)
		template = template.replace(/{{itemId}}/g, product.id);
		template = template.replace(/{{itemTitle}}/g, product.title);
		template = template.replace(/{{itemHandle}}/g, product.handle);
		template = template.replace(/{{itemVendorLabel}}/g, product.vendor);
		template = template.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(product));

		return template;
	};

	ProductGridItem.prototype.buildImages = function (product) {
		const productUrl = Utils.buildProductItemUrl(product);

		const secondaryImage = () => {
			let alternativeFeaturedImage = getMetafieldValue(product, 'media', 'alternative_featured_image') || [];
			let secondaryImage = product.images_info[1];

			if (alternativeFeaturedImage.length) {
				alternativeFeaturedImage = alternativeFeaturedImage[0];

				let src = alternativeFeaturedImage.cloudinary_src;
				let alt = alternativeFeaturedImage.alt ?? product.title;

				return `<picture>
					<img
						src="${src}w_296"
						srcset="${src}w_296 1x, ${src}w592 2x"
						alt="${alt}"
						class="product-card__image product-card__image--secondary"
						loading="lazy"
					/>
				</picture>`;
			}

			if (secondaryImage) {
				let src = secondaryImage.src;
				let alt = secondaryImage.alt ?? product.title;

				return `<picture>
					<img
						src="${src.replace('.jpg', '_296x.jpg')}"
						srcset="${src.replace('.jpg', '_296x.jpg')} 1x, ${src.replace('.jpg', '_592x.jpg')} 2x"
						alt="${alt}"
						class="product-card__image product-card__image--secondary"
						loading="lazy"
					/>
				</picture>`;
			}

			return '';
		};

		const featuredImage = () => {
			let image = Utils.getFeaturedImage(images).replace('_large.jpg', '.jpg');

			if (!image) {
				image = boostPFSAppConfig.general.no_image_url;
			}

			let src = image;
			let alt = image.alt ?? product.title;

			return `<picture>
				<img srcset="${src.replace('.jpg', '_296x.jpg')} 1x, ${src.replace('.jpg', '_960x.jpg')} 2x"
					src="${src.replace('.jpg', '_296x.jpg')}"
					alt="${alt}"
					class="product-card__image"
					loading="lazy"
				/>
			</picture>`;
		};

		return `<a href="${productUrl}" class="product-card__image-wrapper">
			${secondaryImage()}
			${featuredImage()}
		</a>`;
	};

	ProductGridItem.prototype.buildBadges = function (product) {
		let tags = product.tags.join(', ').toLowerCase();

		let badgePreOrder = '';
		let badgeSoldOut = '';
		let badgeSale = '';

		if (tags.includes('pre-order')) {
			badgePreOrder = boostPFSTemplate.badgePreOrderHtml;
		}

		if (!product.available) {
			badgeSoldOut = boostPFSTemplate.badgeSoldOutHtml;
		}

		if (product.compare_at_price_min > product.price_min) {
			badgeSale = boostPFSTemplate.badgeSaleHtml;
		}

		if (badgePreOrder) {
			badgeSoldOut = '';
			badgeSale = '';
		}

		if (badgeSoldOut) {
			badgeSale = '';
		}

		return `${badgePreOrder}${badgeSoldOut}${badgeSale}`;
	};

	ProductGridItem.prototype.buildMeta = function (product) {
		let { title } = product;

		let url = Utils.buildProductItemUrl(product);

		let productTitle 	= getMetafieldValue(product, 'descriptors', 'name') ?? title;
		let productSubtitle = getMetafieldValue(product, 'descriptors', 'subtitle');

		let productTitleHtml = `<a href="${url}" class="product-card__title">
			${productTitle}
		</a>`;

		let productSubtitleHtml = productSubtitle ?
			`<div class="product-card__subtitle">
				${productSubtitle}
			</div>` : '';

		let productPriceHtml = `
			<div class="product-card__price">
				${this.buildProductPrice(product)}
			</div>`;

		let productCookingInfoBadgesHtml = this.buildCookingInfoBadges(product);

		return `${productTitleHtml}${productSubtitleHtml}${productPriceHtml}${productCookingInfoBadgesHtml}`;
	};

	ProductGridItem.prototype.buildProductPrice = function (product) {
		let { tags, variants, price, price_min, compare_at_price, compare_at_price_min } = product;

		tags = tags.join(', ').toLowerCase();

		let isCutToOrder = tags.includes('cut-to-order');
		let isPreOrder = tags.includes('pre-order');

		let availableFromDate = this.getAvailableFromDate(product, isPreOrder, isCutToOrder);

		let productPriceHtml = '';
		let availableFromInfo = '';
		if (availableFromDate && boostPFSConfig.label.available_from) {
			availableFromInfo = boostPFSConfig.label.available_from.replace(/{{ date }}/, availableFromDate);
		}

		if (isCutToOrder) {
			const metafieldPrices = getMetafieldsByNamespace(product, 'price');

			let minProductPrice = price_min * 1000;
			let minComparePrice = +compare_at_price_min * 1000;

			if (!!metafieldPrices) {
				const minProductPriceMetafield = metafieldPrices.per_kg_price.reduce(
					(previous, current) => +previous.value < +current.value ? previous : current
				);

				minProductPrice = +minProductPriceMetafield.value;
				minComparePrice = +metafieldPrices?.per_kg_compare_at_price?.find(
					(metafield) => metafield.id === minProductPriceMetafield.id
				)?.value;

				if (!minProductPrice) {
					minProductPrice = price_min * 1000;
					minComparePrice = +compare_at_price_min * 1000;
				}
			}

			if (minComparePrice > minProductPrice && boostPFSConfig.label.sale_from_price_html) {
				productPriceHtml = `<p class="product-card__price-value product-card__price-value--compare-price">
					${boostPFSConfig.label.sale_from_price_html.replace(/{{ price }}/, Utils.formatMoney(minProductPrice))}
					<span data-available-from>${availableFromInfo}</span>
				</p>`;
			} else {
				productPriceHtml = `<p class="product-card__price-value">
					${boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(minProductPrice))}
					<span data-available-from>${availableFromInfo}</span>
				</p>`;
			}
		} else {
			if (compare_at_price_min > price_min) {
				productPriceHtml = `<p class="product-card__price-value product-card__price-value--compare-price">
					${Utils.formatMoney(price_min)}
				</p>`;
			} else {
				productPriceHtml = `<p class="product-card__price-value">
					${Utils.formatMoney(price_min)}
				</p>`;
			}
		}

		return productPriceHtml;
	};

	ProductGridItem.prototype.buildCookingInfoBadges = function (product) {
		let globalCookingInfoBadgesJson = document.querySelector('[data-cooking-info-badges]');

		if (!globalCookingInfoBadgesJson) {
			return '';
		}

		let globalCookingInfoBadges = JSON.parse(globalCookingInfoBadgesJson.innerHTML);

		let cookingInfo = getMetafieldValue(product, 'cooking_info', 'badges');
		let references = cookingInfo?.references ?? [];

		if (!references.length) {
			return '';
		}

		const productUrl = Utils.buildProductItemUrl(product);

		let badgesHtml = '';

		references.forEach(reference => {
			let index = reference.index;

			let badgeLabel = globalCookingInfoBadges['cooking_info_badge_labels'][index];
			let badgeIcon = globalCookingInfoBadges['cooking_info_badge_icons'][index];

			if (!badgeLabel) {
				return '';
			}

			let badgeIconHtml = badgeIcon ?
				`<span class="product-card__cooking-info-badge-icon">
					${badgeIcon}
				</span>` : '';

			let badgeLabelHtml = `<span class="product-card__cooking-info-badge-label">
				${badgeLabel}
			</span>`;

			let badgeHtml = `<a href="${productUrl}" class="product-card__cooking-info-badge">
				${badgeIconHtml}
				${badgeLabelHtml}
			</a>`;

			badgesHtml += badgeHtml;
		});

		if (!badgesHtml) {
			return '';
		}

		return `<div class="product-card__cooking-info-badges">
			${badgesHtml}
		</div>`;
	};

	ProductGridItem.prototype.getAvailableFromDate = function (product, isPreOrder, isCutToOrder) {
		let availableFromHtml = '';

		if (hasOnlyDefaultVariant) {
			return availableFromHtml;
		}

		if (isPreOrder || isCutToOrder) {
			const availabilityOptionValues = this.getAvailabilityOptionValues(product?.options_with_values);

			if (!availabilityOptionValues.length) {
				return availableFromHtml;
			}

			if (typeof window.getAvailableDeliveryDates == 'undefined') {
				return availableFromHtml;
			}

			const availableDeliveryDates = window.getAvailableDeliveryDates(availabilityOptionValues);

			availableFromHtml = availableDeliveryDates[0];
		}

		return availableFromHtml;
	};

	ProductGridItem.prototype.getAvailabilityOptionValues = function (optionsWithValues) {
		if (!optionsWithValues.length) {
			return [];
		}

		const availabilityOptionLabels = 'availability,date'.split(',');

		const optionsArray = optionsWithValues.find((option) => {
			return availabilityOptionLabels.includes(option.name);
		})?.values ?? [];

		if (!optionsArray.length) {
			return optionsArray;
		}

		const optionValues = [];

		optionsArray.forEach((option) => optionValues.push(option?.title));

		return optionValues;
	};
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		let html = '';

		if (!boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			return false;
		}

		const sortingArr = Utils.getSortingList();

		if (!sortingArr) {
			return false;
		}

		let paramSort = Globals.queryParams.sort || '';

		// Build content
		let sortingItemsHtml = '';

		for (let k in sortingArr) {
			let activeClass = '';

			if (paramSort == k) {
				activeClass = ' active';
			}

			sortingItemsHtml += `<li class="collection-sort__dropdown-item${activeClass}">
									<button type="button" class="boost-pfs-filter-top-sorting-dropdown-option collection-sort__value" data-sort="${k}">
										${sortingArr[k]}
									</button>
								</li>`;
		}

		html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

		return html;
	};

	ProductSorting.prototype.render = function () {
		const selectors = {
			container: '.boost-pfs-filter-custom-sorting',
			button: '.boost-pfs-filter-top-sorting-dropdown-button'
		};

		const container = jQ(selectors.container);

		if (!container.length) {
			return false;
		}

		const html = this.compileTemplate();

		container.html(html);

		let labelSort = '';

		const paramSort = Globals.queryParams.sort || '';
		const sortingList = Utils.getSortingList();

		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		const button = jQ(selectors.button);
		button.text(labelSort);
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		const selectors = {
			dropdownTrigger: '.boost-pfs-filter-top-sorting-dropdown-trigger',
			dropdownTriggerButton: '.boost-pfs-filter-top-sorting-dropdown-button',
			option: '.boost-pfs-filter-top-sorting-dropdown-option'
		};

		const dropdownTrigger = jQ(selectors.dropdownTrigger);
		const dropdownTriggerButton = jQ(selectors.dropdownTriggerButton);
		const option = jQ(selectors.option);

		option.click(function (e) {
			e.preventDefault();

			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		dropdownTrigger.click(function () {
			dropdownTrigger.toggleClass('active');
		});

		jQ(document).on("click", function (e) {
			if (jQ(e.target).is(dropdownTrigger) === false && jQ(e.target).is(dropdownTriggerButton) === false) {
				jQ(dropdownTrigger).removeClass("active");
			}
		});
	};
	/************************** END BUILD TOOLBAR **************************/

	/************************** START CUSTOMIZATIONS **************************/
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
	};

	FilterResult.prototype.afterRender = function (data, event) {
		const selectors = {
			products: '[data-collection-products]'
		};

		const modifiers = {
			loading: 'boost-loading'
		};

		jQ(selectors.products).removeClass(modifiers.loading);
	};
	/************************** END CUSTOMIZATIONS **************************/

	/************************** START HELPERS **************************/
	function getMetafieldValue(product, namespace, key) {
		const metafield = product.metafields.find(
			metafield => metafield.namespace === namespace && metafield.key === key
		);

		if (!metafield) {
			return null;
		}

		try {
			return JSON.parse(metafield.value);
		} catch {
			return metafield.value;
		}
	}

	function getMetafieldsByNamespace(product, namespace) {
		const metafields = product.metafields.filter(
			metafield => metafield.namespace === namespace
		);

		const result = metafields.reduce((accumulator, current) => {
			accumulator[current['key']] =
				[...accumulator[current['key']] || [], current];

			return accumulator;
		}, {});

		if (!Object.keys(result).length) {
			return null;
		}

		return result;
	}
	/************************** END HELPERS **************************/
})();
